import { supabase } from '../supabase/client';

export interface LocalMediaFile {
  file: File;
  previewUrl: string;
  type: 'image' | 'video';
  url: string;
  metadata?: {
    name: string;
    size: number;
    type: string;
    path: string;
  };
}

export const uploadMedia = async (file: File, path: string): Promise<string> => {
  try {
    console.log('Starting media upload:', { path, fileSize: file.size, fileType: file.type });

    // Check auth state first
    const { data: { session }, error: authError } = await supabase.auth.getSession();
    
    if (authError || !session) {
      throw new Error('Please sign in to upload files');
    }

    // Validate file size (200MB limit)
    if (file.size > 200 * 1024 * 1024) {
      throw new Error('File size exceeds 200MB limit');
    }

    // Validate file type
    if (!file.type.startsWith('image/') && !file.type.startsWith('video/')) {
      throw new Error('Only image and video files are allowed');
    }

    console.log('Uploading to storage:', path);

    // Upload to Supabase storage
    const { data: uploadData, error: uploadError } = await supabase.storage
      .from('experience-media')
      .upload(path, file, {
        upsert: true,
        contentType: file.type,
        cacheControl: '3600'
      });

    if (uploadError) {
      console.error('Upload error:', uploadError);
      throw uploadError;
    }

    console.log('Upload successful:', uploadData);

    // Get the public URL
    const { data: { publicUrl } } = supabase.storage
      .from('experience-media')
      .getPublicUrl(uploadData.path);

    console.log('Public URL generated:', publicUrl);

    return publicUrl;
  } catch (error) {
    console.error('Upload failed:', error);
    throw error;
  }
};